export const ROUTES = {
  NOT_FOUND: '/not-found',
  ORGANIZATION_LEVEL_PAGES: '/organizations/:encoded_organization_id',
  PROGRAM_LEVEL_PAGES: '/organizations/:encoded_organization_id/programs/:encoded_program_id',
  GET_APP: '/apps/:encoded_app_id',
}
